export default __webpack_public_path__ + "static/media/gallery_08.d0b14d19.jpg";